'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ResponseRowIdCombination = undefined;

var _arrayContains = require('d2-utilizr/lib/arrayContains');

var _arrayContains2 = _interopRequireDefault(_arrayContains);

var _arrayFrom = require('d2-utilizr/lib/arrayFrom');

var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

var _isArray = require('d2-utilizr/lib/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResponseRowIdCombination = exports.ResponseRowIdCombination = undefined;

exports.ResponseRowIdCombination = ResponseRowIdCombination = function ResponseRowIdCombination(refs, config) {
    var t = this;

    config = (0, _isArray2.default)(config) ? config.reduce(function (acc, cur) {
        return acc += (acc.length === 0 ? '' : '-') + cur;
    }, '') : null;
    config = (0, _isString2.default)(config) ? config : '';

    // constructor
    t.ids = config;
};

ResponseRowIdCombination.prototype.add = function (id) {
    if (id) {
        this.ids += (this.ids.length === 0 ? '' : '-') + id;
    }
};

ResponseRowIdCombination.prototype.get = function () {
    return this.ids;
};

ResponseRowIdCombination.prototype.getNames = function (response, ignoreIndexes) {
    var ids = this.ids.split('-');

    if ((0, _isArray2.default)(ignoreIndexes)) {
        ids = ids.filter(function (id, index) {
            return !(0, _arrayContains2.default)(ignoreIndexes, index);
        });
    }

    return ids.map(function (id) {
        return response.getNameById(id);
    });
};

ResponseRowIdCombination.prototype.getIdByIds = function (ids) {
    return this.ids.split('-').filter(function (id) {
        return (0, _arrayContains2.default)((0, _arrayFrom2.default)(ids), id);
    })[0];
};
//# sourceMappingURL=ResponseRowIdCombination.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/api/ResponseRowIdCombination.js
 ** module id = 42
 ** module chunks = 0 1
 **/